import {
  canFinance,
  canOperate,
  canPlan,
  canWriteOrders,
  roleCanSeeField,
} from "@/domain/access";
import { hasCustomerPermission } from "@/domain/permissions";
import { effectiveModules, useAccessStore } from "@/store/access.store";
import { useSessionStore } from "@/store/session.store";

function useAccess() {
  const role = useAccessStore((s) => s.role);
  const entitlements = useAccessStore((s) => s.entitlements);
  const permissions = useAccessStore((s) => s.permissions);
  const activeCompanyId = useAccessStore((s) => s.activeCompanyId);
  const allowedCompanyIds = useAccessStore((s) => s.allowedCompanyIds);
  const modules = effectiveModules(role, entitlements);
  const user = useSessionStore((s) => s.user);

  const can = (permissionId) => {
    if (user?.isPlatformPreview) return true;
    return hasCustomerPermission(
      { permissions },
      permissionId,
      { modules: entitlements, role },
    );
  };

  return {
    role,
    entitlements,
    permissions,
    activeCompanyId,
    allowedCompanyIds,
    modules,
    can,
    canSee: (field) => roleCanSeeField(role, field),
    canWriteOrders: canWriteOrders(role),
    canPlan: canPlan(role),
    canOperate: canOperate(role),
    canFinance: canFinance(role),
    hasModule: (key) => modules.includes(key),
    isDriver: role === "driver",
    isGroupAdmin: role === "group_admin",
    isPortMember: role === "port_member",
    isBuyer: role === "buyer",
    isSeller: role === "seller",
  };
}
export { useAccess };
